import {Tr} from "@/i18n/i18n";
import {EffectType} from "@/store/artifact/types";
import Scene = Phaser.Scene;
import {Creature} from "@/store/level/types";
import PlayerStore from "@/store/player";
import SkillUtils from "@/utils/skill-utils";
import {ArenaLeague} from "@/store/arena/types";
import {Keys} from "@/constants/key";

export default class ArenaUtils {

    public static getLeagueImg(league: ArenaLeague): string {
        switch (league) {
            case ArenaLeague.FIRST:
                return Keys.LEAGUE_1;
            case ArenaLeague.SECOND:
                return Keys.LEAGUE_2;
            case ArenaLeague.THIRD:
                return Keys.LEAGUE_3;
            case ArenaLeague.FOURTH:
                return Keys.LEAGUE_4;
            case ArenaLeague.FIFTH:
                return Keys.LEAGUE_5;
            case ArenaLeague.SIXTH:
                return Keys.LEAGUE_6;
            case ArenaLeague.SEVENTH:
                return Keys.LEAGUE_7;
            case ArenaLeague.EIGHTH:
                return Keys.LEAGUE_8;
            case ArenaLeague.NINTH:
                return Keys.LEAGUE_9;
        }
    }

    public static getLeagueImgSmall(league: ArenaLeague): string {
        switch (league) {
            case ArenaLeague.FIRST:
                return Keys.LEAGUE_1_SMALL;
            case ArenaLeague.SECOND:
                return Keys.LEAGUE_2_SMALL;
            case ArenaLeague.THIRD:
                return Keys.LEAGUE_3_SMALL;
            case ArenaLeague.FOURTH:
                return Keys.LEAGUE_4_SMALL;
            case ArenaLeague.FIFTH:
                return Keys.LEAGUE_5_SMALL;
            case ArenaLeague.SIXTH:
                return Keys.LEAGUE_6_SMALL;
            case ArenaLeague.SEVENTH:
                return Keys.LEAGUE_7_SMALL;
            case ArenaLeague.EIGHTH:
                return Keys.LEAGUE_8_SMALL;
            case ArenaLeague.NINTH:
                return Keys.LEAGUE_9_SMALL;
        }
    }

    public static getLeagueName(league: ArenaLeague): string {
        switch (league) {
            case ArenaLeague.FIRST:
                return Tr('liga.1');
            case ArenaLeague.SECOND:
                return Tr('liga.2');
            case ArenaLeague.THIRD:
                return Tr('liga.3');
            case ArenaLeague.FOURTH:
                return Tr('liga.4');
            case ArenaLeague.FIFTH:
                return Tr('liga.5');
            case ArenaLeague.SIXTH:
                return Tr('liga.6');
            case ArenaLeague.SEVENTH:
                return Tr('liga.7');
            case ArenaLeague.EIGHTH:
                return Tr('liga.8');
            case ArenaLeague.NINTH:
                return Tr('liga.9');
        }
    }

    public static getLeagueColor(league: ArenaLeague): string {
        switch (league) {
            case ArenaLeague.FIRST:
                return '#85ff85';
            case ArenaLeague.SECOND:
                return '#86d9b1';
            case ArenaLeague.THIRD:
                return '#8ea9e5';
            case ArenaLeague.FOURTH:
                return '#f3cb8e';
            case ArenaLeague.FIFTH:
                return '#f7f3f2';
            case ArenaLeague.SIXTH:
                return '#ecd285';
            case ArenaLeague.SEVENTH:
                return '#aef3ee';
            case ArenaLeague.EIGHTH:
                return '#c181d6';
            case ArenaLeague.NINTH:
                return '#ec9095';
        }
    }

    public static getLeagueNumber(league: ArenaLeague): number {
        switch (league) {
            case ArenaLeague.FIRST:
                return 1;
            case ArenaLeague.SECOND:
                return 2;
            case ArenaLeague.THIRD:
                return 3;
            case ArenaLeague.FOURTH:
                return 4;
            case ArenaLeague.FIFTH:
                return 5;
            case ArenaLeague.SIXTH:
                return 6;
            case ArenaLeague.SEVENTH:
                return 7;
            case ArenaLeague.EIGHTH:
                return 8;
            case ArenaLeague.NINTH:
                return 9;
        }
    }
}
